import { Field, Float, Int, ObjectType } from '@nestjs/graphql'
import { UserReviewerRateStats } from './reviewerRateStats.dto'

@ObjectType()
export class UserReviewerStatsDto {
  @Field(type => Int)
  arcsDownloadedThisWeek!: number

  @Field(type => Int)
  arcTotalOverdueDays!: number

  @Field(type => UserReviewerRateStats)
  onTimeReviewRateStats!: UserReviewerRateStats

  @Field(type => Boolean)
  isTrustedReviewer!: boolean

  @Field(type => Int)
  totalReviewCount!: number

  @Field(type => Int)
  dueReviewCount!: number

  @Field(type => Int)
  cancelledReviewCount!: number

  @Field(type => Float)
  averageRating!: number

  @Field(type => Int)
  activeArcCount!: number

  @Field({ nullable: true })
  earliestNextClaimDate?: Date
}
